import useHandleActiveSpatialObject from './hooks/useHandleActiveSpatialObject';
import useHandleMessageCategory from './hooks/useHandleMessageCategory';
import useHandleTranscriptionSummaries from './hooks/useHandleTranscriptionSummaries';
import useSpatialLayerIntersect from './hooks/useSpatialLayerIntersect';

/**
 * Empty component that contains hooks usage for Hermes callbacks
 */
const HermesCallbacks = () => {
  useHandleActiveSpatialObject();
  useSpatialLayerIntersect();
  useHandleMessageCategory();
  useHandleTranscriptionSummaries();

  return <></>;
};
export default HermesCallbacks;
